import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";
import { Typography } from "@kaltura/ds-react-components";
import { VisibleFocusStyle } from "@kaltura/ds-react-theme";

export const StyledChannelItem = styled(
    "a",
    {
        label: "ChannelItem",
    }
)({
    display: "inline-block",
    textAlign: "center",
    textDecoration: "none",
    width: 100,
    "&:focus-visible": VisibleFocusStyle,
});

export const Icon = styled(Box)({
    paddingBottom: "100%",
    borderRadius: "50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: 100,
});

export const StyledTypography = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone1,
    fontWeight: theme.kaltura.typography.fontWeightBold,
    marginTop: theme.spacing(1),
}));

export const StyledLi = styled("li")(({ theme }) => ({
    display: "block",
}));
